import React from 'react';
import '../css/LoadingSpinner.css';

const LoadingSpinner = ({ isVisible, backgroundColor }) => {
  return (
    <div className={`loading-overlay ${isVisible ? 'active' : ''}`}
    style={{ backgroundColor }}
    >
      <div className="spinner"></div>
    </div>
  );
};

export default LoadingSpinner;
